export const krishna_yajurvedam_tree_data = {
  braahmanam: {
    pradhamaashtakam: [1, 2, 3, 4, 5, 6, 7, 8],
    dviteeyaashtakam: [1, 2, 3, 4, 5, 6, 7, 8],
    triteeyaashtakam: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  },
  aaranyakamu: {
    mukhyaBhagamu: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    ekaagniKaandamu: [1, 2]
  },
  samhitaa: {
    prathamaKaandamu: [1, 2, 3, 4, 5, 6, 7, 8],
    dviteeyaKaandamu: [1, 2, 3, 4, 5, 6],
    triteeyaKaandamu: [1, 2, 3, 4, 5],
    chaturthaKaandamu: [1, 2, 3, 4, 5, 6, 7],
    panchamaKaandamu: [1, 2, 3, 4, 5, 6, 7],
    shashthaKaandamu: [1, 2, 3, 4, 5, 6],
    sapthamaKaandamu: [1, 2, 3, 4, 5]
  },
  padamu: {
    prathamaKaandamu: [1, 2, 3, 4, 5, 6, 7, 8],
    dviteeyaKaandamu: [1, 2, 3, 4, 5, 6],
    triteeyaKaandamu: [1, 2, 3, 4, 5],
    chaturthaKaandamu: [1, 2, 3, 4, 5, 6, 7],
    panchamaKaandamu: [1, 2, 3, 4, 5, 6, 7],
    shashthaKaandamu: [1, 2, 3, 4, 5, 6],
    sapthamaKaandamu: [1, 2, 3, 4, 5]
  },
  kramamu: {
    prathamaKaandamu: [1, 2, 3, 4, 5, 6, 7, 8],
    dviteeyaKaandamu: [1, 2, 3, 4, 5, 6],
    triteeyaKaandamu: [1, 2, 3, 4, 5],
    chaturthaKaandamu: [1, 2, 3, 4, 5, 6, 7],
    panchamaKaandamu: [1, 2, 3, 4, 5, 6, 7],
    shashthaKaandamu: [1, 2, 3, 4, 5, 6],
    sapthamaKaandamu: [1, 2, 3, 4, 5]
  },
  jata: {},
  ghanamu: {}
}

export const krishna_yajurvedam_tree_labels = {
  braahmanam: {
    _self: { telugu: "బ్రాహ్మణము", sanskrit: "ब्रह्मणम्", english: "braahmanam" },
    pradhamaashtakam: { telugu: "ప్రథమాష్టకము", sanskrit: "प्रथमाष्टकम्", english: "pradhamaashtakam", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    dviteeyaashtakam: { telugu: "ద్వితీయాష్టకము", sanskrit: "द्वितीयाष्टकम्", english: "dviteeyaashtakam", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    triteeyaashtakam: { telugu: "తృతీయాష్ఠకము", sanskrit: "तृतीयाष्टकम्", english: "triteeyaashtakam", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} }
  },
  aaranyakamu: {
    _self: { telugu: "ఆరణ్యకము", sanskrit: "आरण्यकम्", english: "aaranyakamu" },
    mukhyaBhagamu: { telugu: "ముఖ్య భాగము", sanskrit: "मुख्य भागः", english: "main", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    ekaagniKaandamu: { telugu: "ఏకాగ్ని కాండము", sanskrit: "एकाग्निकाण्डम्", english: "ekaagniKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} }
  },
  samhitaa: {
    _self: { telugu: "సంహితా", sanskrit: "संहिता", english: "samhita" },
    prathamaKaandamu: { telugu: "ప్రథమకాండము", sanskrit: "प्रथमकाण्डम्", english: "prathamaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    dviteeyaKaandamu: { telugu: "ద్వితీయకాండము", sanskrit: "द्वितीयकाण्डम्", english: "dviteeyaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    triteeyaKaandamu: { telugu: "తృతీయకాండము", sanskrit: "तृतीयकाण्डम्", english: "triteeyaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    chaturthaKaandamu: { telugu: "చతుర్థకాండము", sanskrit: "चतुर्थकाण्डम्", english: "chaturthaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    panchamaKaandamu: { telugu: "పంచమకాండము", sanskrit: "पञ्चमकाण्डम्", english: "panchamaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english:"Prashna "} },
    shashthaKaandamu: { telugu: "షష్ఠకాండము", sanskrit: "षष्टकाण्डम्", english:"shashthaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    sapthamaKaandamu: { telugu: "సప్తమకాండము", sanskrit: "सप्तमकाण्डम्", english: "sapthamaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} }
  },
  padamu: {
    _self: { telugu: "పదము", sanskrit: "पदम्", english: "padamu" },
    prathamaKaandamu: { telugu: "ప్రథమకాండము", sanskrit: "प्रथमकाण्डम्", english: "prathamaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    dviteeyaKaandamu: { telugu: "ద్వితీయకాండము", sanskrit: "द्वितीयकाण्डम्", english: "dviteeyaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    triteeyaKaandamu: { telugu: "తృతీయకాండము", sanskrit: "तृतीयकाण्डम्", english: "triteeyaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    chaturthaKaandamu: { telugu: "చతుర్థకాండము", sanskrit: "चतुर्थकाण्डम्", english: "chaturthaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    panchamaKaandamu: { telugu: "పంచమకాండము", sanskrit: "पञ्चमकाण्डम्", english: "panchamaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english:"Prashna "} },
    shashthaKaandamu: { telugu: "షష్ఠకాండము", sanskrit: "षष्टकाण्डम्", english:"shashthaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    sapthamaKaandamu: { telugu: "సప్తమకాండము", sanskrit: "सप्तमकाण्डम्", english: "sapthamaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} }
  },
  kramamu: {
    _self: { telugu: "క్రమము", sanskrit: "क्रमम्", english: "kramamu" },
    prathamaKaandamu: { telugu: "ప్రథమకాండము", sanskrit: "प्रथमकाण्डम्", english: "prathamaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    dviteeyaKaandamu: { telugu: "ద్వితీయకాండము", sanskrit: "द्वितीयकाण्डम्", english: "dviteeyaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    triteeyaKaandamu: { telugu: "తృతీయకాండము", sanskrit: "तृतीयकाण्डम्", english: "triteeyaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    chaturthaKaandamu: { telugu: "చతుర్థకాండము", sanskrit: "चतुर्थकाण्डम्", english: "chaturthaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    panchamaKaandamu: { telugu: "పంచమకాండము", sanskrit: "पञ्चमकाण्डम्", english: "panchamaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english:"Prashna "} },
    shashthaKaandamu: { telugu: "షష్ఠకాండము", sanskrit: "षष्टकाण्डम्", english: "shashthaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} },
    sapthamaKaandamu: { telugu: "సప్తమకాండము", sanskrit: "सप्तमकाण्डम्", english: "sapthamaKaandamu", suffix: { telugu: "వ ప్రశ్న", sanskrit: " प्रश्नः"}, prefix: {english: "Prashna "} }
  },
  jata: {_self: { telugu: "జట", sanskrit: "जट", english: "jata" } },
  ghanamu: {_self: { telugu: "ఘనము", sanskrit: "घनम्", english: "ghanamu" } }
}

export const lakshanm_tree_data = {
    praatishaakhyam: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
    vyaasasheeksha: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
    varnakramam: {},
    saptalakshani: [1, 2, 3, 4, 5, 6, 7],
    atreyasheeksha: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
    koundinyasheeksha: {}
}

export const lakshanm_tree_labels = {
    praatishaakhyam: { telugu: "ప్రాతిశాఖ్య", sanskrit: "प्रातिशाख्यम्", english: "praatishaakhyam", suffix: { telugu: " వ అధ్యాయం", sanskrit: " अध्यायः" }, prefix: {english: "Adhyayam "} },
    vyaasasheeksha: { telugu: "వ్యాసశీక్ష", sanskrit: "व्यासशीक्षा", english: "vyaasasheeksha", suffix: { telugu: " వ ప్రకరణం", sanskrit: " प्रकरणम्" }, prefix: {english: "Prakaranam "} },
    varnakramam: { telugu: "వర్ణక్రమం", sanskrit: "वर्णक्रमम्", english: "varnakramam" },
    saptalakshani: { telugu: "సప్తలక్షణి", sanskrit: "सप्तलक्षणि", english: "saptalakshani", suffix: { telugu: " వ ప్రకరణం", sanskrit: " प्रकरणम्" }, prefix: {english: "Prakaranam "} },
    atreyasheeksha: { telugu: "ఆత్రేయశీక్ష", sanskrit: "अत्रेयशीक्षा", english: "atreyasheeksha", suffix: { telugu: " వ అధ్యాయం", sanskrit: " अध्यायः" }, prefix: {english: "Adhyayam "} },
    koundinyasheeksha: { telugu: "కౌండిన్యశీక్ష", sanskrit: "कौण्डिन्यशीक्षा", english: "koundinyasheeksha" }
}

export const lakshanam_variant_labels = {
  kanthastham: {
    telugu: "కంఠస్థం",
    sanskrit: "कण्ठस्थम्",
    english: "Kanthastham"
  },
  vyakhyanam: {
    telugu: "వ్యాఖ్యానం",
    sanskrit: "व्याख्यानम्",
    english: "Vyakhyanam"
  }
};

export const sanskrit_tree_data = {
  shabdaManjari: {
    saamanyaShabdaalu: {},
    sarvanaamaShabdaalu: {},
    visheshaShabdaalu: {}
  },
  twentyDhatuvulu: {},
  samaasaKusumaavali: {},
  amaraKosha: {
    prathamaKaandam: {},
    dviteeyaKaandam: {},
    triteeyaKaandam: {}
  },
  raghuVamsham: {},
  kumaaraSambhavam: {},
  shishupaalaVadham: {},
  kiraataarjuneeyam: {},
  naishadham: {},
  abhijnaanaShaakuntalam: {},
  dashakumaaraCharitam: {},
  champuRaamaayanam: {},
  champuBhaaratam: {},
  aapastambaDharmaSuutram: {},
  aapastambaGrihyaSuutram: {},
  laghuSiddhaantaKaumudee: {},
};

export const sanskrit_tree_labels = {
  shabdaManjari: {
    _self: { telugu: "శబ్దమంజరి", sanskrit: "शब्दमञ्जरी", english: "shabdaManjari" },
    saamanyaShabdaalu: { telugu: "సామాన్య శబ్దాలు", sanskrit: "सामान्य शब्दाः", english: "saamanyaShabdaalu" },
    sarvanaamaShabdaalu: { telugu: "సర్వనామ శబ్దాలు", sanskrit: "सर्वनाम शब्दाः", english: "sarvanaamaShabdaalu" },
    visheshaShabdaalu: { telugu: "విశేష శబ్దాలు", sanskrit: "विशेष शब्दाः", english: "visheshaShabdaalu" }
  },
  twentyDhatuvulu: { telugu: "సంస్థ సూచించిన 20 ధాతువులు", sanskrit: "संस्थ सूचिता 20 धातवः", english: "twentyDhatuvulu" },
  samaasaKusumaavali: { telugu: "సమాసకుసుమావళి", sanskrit: "समासकुसुमावली", english: "samaasaKusumaavali" },
  amaraKosha: {
    _self: { telugu: "అమరకోశం", sanskrit: "अमरकोशः", english: "amaraKosha" },
    prathamaKaandam: { telugu: "ప్రథమ కాండ", sanskrit: "प्रथम काण्डम्", english: "prathamaKaandam" },
    dviteeyaKaandam: { telugu: "2 వ కాండ", sanskrit: "2 व काण्डम्", english: "dviteeyaKaandam" },
    triteeyaKaandam: { telugu: "3 వ కాండ", sanskrit: "3 व काण्डम्", english: "triteeyaKaandam" }
  },
  raghuVamsham: { telugu: "రఘువంశము-1 వ సర్గ", sanskrit: "रघुवंशम्-1 सर्गः", english: "raghuVamsham" },
  kumaaraSambhavam: { telugu: "కుమార సంభవం-1 వ సర్గ", sanskrit: "कुमारसंभवम्-1 सर्गः", english: "kumaaraSambhavam" },
  shishupaalaVadham: { telugu: "శిశుపాలవధం-1 వ సర్గ", sanskrit: "शिशुपालवधम्-1 सर्गः", english: "shishupaalaVadham" },
  kiraataarjuneeyam: { telugu: "కిరాత అర్జునీయం 1 వ సర్గ", sanskrit: "किरातार्जुनीयम् 1 सर्गः", english: "kiraataarjuneeyam" },
  naishadham: { telugu: "నైషధం-1 వ సర్గ", sanskrit: "नैषधम्-1 सर्गः", english: "naishadham" },
  abhijnaanaShaakuntalam: { telugu: "అభిజ్ఞాన శాకుంతలం- చతుర్థ అంకమ్", sanskrit: "अभिज्ञानशाकुन्तलम्- प्रथम अङ्कम्", english: "abhijnaanaShaakuntalam" },
  dashakumaaraCharitam: { telugu: "దశకుమార చరితం- ప్రథమ ఉచ్ఛ్వాసం", sanskrit: "दशकुमारचरितम्- प्रथम उच्छ्वासम्", english: "dashakumaaraCharitam" },
  champuRaamaayanam: { telugu: "చంపూ రామాయణం-బాల కాండ", sanskrit: "चम्पु रामायणम्-बाल काण्डम्", english: "champuRaamaayanam" },
  champuBhaaratam: { telugu: "చంపూ  భారతం - ప్రథమ స్తబకం", sanskrit: "चम्पु भारतम् - प्रथम स्तबकम्", english: "champuBhaaratam" },
  aapastambaDharmaSuutram: { telugu: "ఆపస్తంబ ధర్మ సూత్రం  మూలం సంపూర్ణం", sanskrit: "आपस्तम्ब धर्मसूत्रम्  मूलम् सम्पूर्णम्", english: "aapastambaDharmaSuutram" },
  aapastambaGrihyaSuutram: { telugu: "ఆపస్తంబ గృహ్య సూత్రం మూలం సంపూర్ణo", sanskrit: "आपस्तम्ब गृह्यसूत्रम् मूलम् सम्पूर्णम्", english: "aapastambaGrihyaSuutram" },
  laghuSiddhaantaKaumudee: { telugu: "సిద్ధాంత కౌముది- పంచ సంధి ప్రకరణ పర్యంతం", sanskrit: "लघु सिद्धान्त कौमुदी- पञ्चसन्धि प्रकरण पर्यन्तम्", english: "laghuSiddhaantaKaumudee" }
};

export const vedadhyayi_tree_data = {
  amaraKosha: {
    shataShloka: {},
    panchashadadhikaShataShloka: {},
    dvishataShloka: {},
    panchashadadhikaDvishataShloka: {},
    trishataShloka: {},
    panchashadadhikaTrishataShloka: {}
  },
  shabdaManjari: {},
  dhaatavaH: {},
  samaasaKusumaavali: {},
  raghuVamsham: {},
  kumaaraSambhavam: {},
  kiraataarjuneeyam: {},
  shishupaalaVadham: {},
  naishadham: {}
};

export const vedadhyayi_tree_labels = {
  amaraKosha: {
    _self: { telugu: "అమరకోశం", sanskrit: "अमरकोशः", english: "amaraKosha" },
    shataShloka: { telugu: "100 శ్లోకాలు", sanskrit: "100 श्लोकाः", english: "shataShloka" },
    panchashadadhikaShataShloka: { telugu: "150 శ్లోకాలు", sanskrit: "150 श्लोकाः", english: "panchashadadhikaShataShloka" },
    dvishataShloka: { telugu: "200 శ్లోకాలు", sanskrit: "200 श्लोकाः", english: "dvishataShloka" },
    panchashadadhikaDvishataShloka: { telugu: "250 శ్లోకాలు", sanskrit: "250 श्लोकाः", english: "panchashadadhikaDvishataShloka" },
    trishataShloka: { telugu: "300 శ్లోకాలు", sanskrit: "300 श्लोकाः", english: "trishataShloka" },
    panchashadadhikaTrishataShloka: { telugu: "350 శ్లోకాలు", sanskrit: "350 श्लोकाः", english: "panchashadadhikaTrishataShloka" }
  },
  shabdaManjari: { telugu: "శబ్దమంజరి", sanskrit: "शब्दमञ्जरी", english: "shabdaManjari" },
  dhaatavaH: { telugu: "ధాతువులు (భ్వాది 10 గణములలో 2 చొప్పున ధాతువులు)", sanskrit: "धातवः (भ्वादि 10 गणेषु 2 प्रतिगणम्)", english: "dhaatavaH" },
  samaasaKusumaavali: { telugu: "సమాసకుసుమావళి", sanskrit: "समासकुसुमावली", english: "samaasaKusumaavali" },
  raghuVamsham: { telugu: "రఘువంశము-1 వ సర్గ", sanskrit: "रघुवंशम्-1 सर्गः", english: "raghuVamsham" },
  kumaaraSambhavam: { telugu: "కుమార సంభవం-1 వ సర్గ", sanskrit: "कुमारसंभवम्-1 सर्गः", english: "kumaaraSambhavam" },
  kiraataarjuneeyam: { telugu: "కిరాత అర్జునీయం 1 వ సర్గ", sanskrit: "किरातार्जुनीयम् 1 सर्गः", english: "kiraataarjuneeyam" },
  shishupaalaVadham: { telugu: "శిశుపాలవధం-1 వ సర్గ", sanskrit: "शिशुपालवधम्-1 सर्गः", english: "shishupaalaVadham" },
  naishadham: { telugu: "నైషధం-1 వ సర్గ", sanskrit: "नैषधम्-1 सर्गः", english: "naishadham" }
};

export const no_data_labels = {
  _self: { telugu: "ఏమీ ఇవ్వలేదు", sanskrit: "किमपि नोक्तम्", english: "Did not give any exam" }
};